import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { GetDistributionOfComplaints } from "api/apiService";
import { MyTableProps } from "components/controls/Table/Table";
import React, { useEffect, useState } from "react";
import { NilonLevelTableDataItemApiResponse } from "types/NilonLevelTableTypes";
import { PeriodState } from "types/PeriodSelectionTypes";
import { NUM_OF_ROWS_FOR_TABLE, getCategoryFilters } from "utils/utils";

interface UseTableProps extends MyTableProps {
    period: PeriodState;
}
const useTable = ({ chosenCategoryIndex, period, optionId }: UseTableProps) => {
    const [isLastPage, setLastPage] = useState(false);

    useEffect(() => {
        // clean the last page when filter
        setLastPage(false)
    }, [chosenCategoryIndex, period]);

    const { data, fetchNextPage, isFetching, isLoading, refetch, isFetchingNextPage } =
        useInfiniteQuery<NilonLevelTableDataItemApiResponse>({
            queryKey: ["nilonDataTableItem", chosenCategoryIndex, period, optionId],
            queryFn: ({ pageParam = 0 }) => fetchWithPages(pageParam),
            initialPageParam: 0,
            getNextPageParam: (_lastGroup, groups) => groups.length,
            refetchOnWindowFocus: false,

            placeholderData: keepPreviousData,

        });

    const flatData = React.useMemo(
        () => data?.pages?.flatMap((page) => page.data) ?? [],
        [data]
    );
    const fetchWithPages = async (pageParam: unknown) => {
        const start = (pageParam as number) * NUM_OF_ROWS_FOR_TABLE;
        const fetchedData = await GetDistributionOfComplaints(
            getCategoryFilters()[chosenCategoryIndex],
            start,
            NUM_OF_ROWS_FOR_TABLE,
            optionId
        );
        if (fetchedData.data.length < NUM_OF_ROWS_FOR_TABLE) {
            setLastPage(true)
        }
        return fetchedData;
    }
    return { data, flatData, isLastPage, fetchNextPage, isFetching, isLoading, refetch, isFetchingNextPage };
};


export default useTable;

